import { useEffect } from 'react';
import { createFileRoute, useRouter, useSearch } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/dashboard/jobs/$id/payment-schedule/new')({
  component: NewPaymentSchedulePageRoute,
});

function NewPaymentSchedulePageRoute() {
  const { id } = Route.useParams();
  const router = useRouter();
  const search = useSearch({ strict: false }) as Record<string, unknown>;

  useEffect(() => {
    void router.navigate({
      to: '/dashboard/jobs/$id',
      params: { id },
      search: {
        ...search,
        tab: 'billing',
        paymentScheduleDrawer: 'new',
      },
      replace: true,
    });
  }, [id, router, search]);

  return (
    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
      <Loader2 className="mr-2 size-4 animate-spin" />
      Opening payment schedule...
    </div>
  );
}
